import qs from 'qs'
import urlParser from 'url'
import makeDebug from 'debug'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const debug = makeDebug('url-utils')

export class Url {
  static addParamsToUrl = (
    url: string,
    paramsObj: Record<string, string | number | boolean | Array<string | number | boolean>>
  ) => {
    const normalizedParamsObj: Record<string, string> = {}
    for (const [key, value] of Object.entries(paramsObj)) {
      if (Array.isArray(value)) {
        normalizedParamsObj[key] = String(value.join(','))
      } else {
        normalizedParamsObj[key] = String(value)
      }
    }

    const { query, ...urlObj } = urlParser.parse(url)
    urlObj.search = qs.stringify(
      {
        ...qs.parse(query ?? ''),
        ...qs.parse(normalizedParamsObj),
      },
      { encode: false }
    )
    return urlParser.format(urlObj)
  }

  static updateUrl = (params: { [key: string]: unknown }) => {
    const currentParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    const allParams = {
      ...currentParams,
      ...params,
    }

    const finalParams: { [key: string]: unknown } = {}
    for (const i in allParams) {
      if (allParams[i] !== null && allParams[i] !== undefined) {
        /* TODO: encode params for valid url */
        finalParams[i] = allParams?.[i]
      }
    }

    const final = qs.stringify(finalParams, { arrayFormat: 'repeat' })
    const paramToPush = final !== '' ? `?${final}` : ''
    const res = window.location.pathname

    window.history.pushState('', '', res + paramToPush)
  }

  static removeParamsFromUrl = (params: string[]) => {
    const currentParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })

    for (const param of params) {
      delete currentParams[param]
    }

    const final = qs.stringify(currentParams, { arrayFormat: 'repeat' })
    const paramToPush = final !== '' ? `?${final}` : ''
    const res = window.location.pathname

    window.history.pushState('', '', res + paramToPush)
  }

  static makeParamsFromObject = (params: { [key: string]: unknown }) => {
    return Object.entries(params).reduce((accumulator, [key, value], index) => {
      if (index === 0) {
        return accumulator + `${key}=${value}`
      }
      return accumulator + `&${key}=${value}`
    }, '?')
  }

  static isCountryInUrl = (country: string) => {
    return window.location.pathname.includes(country)
  }

  static decodeFacet = (facet: string) => {
    if (!facet) {
      return ''
    }
    return facet.replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(parseInt(p1, 16)))
  }
}
